export default "__VITE_ASSET__pNXG8VKR__"